import React, { useState } from "react";
import PropTypes from "prop-types";
import UnifiedSearchAutocompleteComponent from "../../unified_search_autocomplete_component";

const UserSearchForm = ({ selectedSearchUser, accountStatus }) => {
  const [searchUser, setSearchUser] = useState(selectedSearchUser || "");

  const handleFormSubmit = (userName) => {
    const normalizedUserName = userName.trim();

    const searchParams = new URLSearchParams({ account_status: accountStatus });
    if (normalizedUserName) searchParams.set("search_user", normalizedUserName);
    window.location.href = `/admin/users?${searchParams.toString()}`;
  };

  const handleDropdownItemClick = (option) => {
    const updatedSearchUser = option.name;
    setSearchUser(updatedSearchUser);
    handleFormSubmit(updatedSearchUser);
  };

  const handleClearClick = () => {
    const updatedSearchUser = "";
    setSearchUser(updatedSearchUser);
    handleFormSubmit(updatedSearchUser);
  };

  const handleInputChange = (e) => {
    setSearchUser(e.target.value);
  };

  return (
    <div className="user-search-bar ccw-admin-user-search" role="search">
      <span className="ccw-field__label">Find a user</span>
      <div className="control">
        <UnifiedSearchAutocompleteComponent
          input_field_name="search_user"
          selected_name={searchUser}
          options={[]}
          handleInputChange={handleInputChange}
          hardCodedOptions={[]}
          handleFormSubmit={() => handleFormSubmit(searchUser)}
          handleDropdownItemClick={handleDropdownItemClick}
          handleClearClick={handleClearClick}
          inputFieldId="auto-complete-user-input-box"
          inputFieldPlaceholder="Search users by name"
          handleInputFocus={() => {}}
        />
      </div>
    </div>
  );
};

UserSearchForm.propTypes = {
  selectedSearchUser: PropTypes.string,
  accountStatus: PropTypes.string
};

UserSearchForm.defaultProps = {
  selectedSearchUser: "",
  accountStatus: "current"
};

export default UserSearchForm;
